import appConfig, {HOME, WALLET} from "@irati-web/app/src/routeConfig"
import {
  ADD_PEOPLE_SINGLE,
  ADD_TEAM,
  ASSIGN_MANAGERS,
  SETTINGS_CUSTOMISE_BENEFITS,
  SETTINGS_CUSTOMISE_BRAND,
  SETTINGS_CUSTOMISE_CELEBRATIONS,
  SETTINGS_CUSTOMISE_VALUES,
  SETTINGS_CUSTOMISE_WELCOME_EMAIL,
  SETTINGS_LOGIN_INTEGRATION_DSYNC,
  SETTINGS_LOGIN_INTEGRATION_SSO,
  VIEW_BUSINESS_UNITS
} from "../../../routes/routeConfig"

export interface Step {
  id?: string
  title: string
  event: string
  actions: Action[]
}

export interface Action {
  name: string
  complete: boolean
  title: string
  subTitle: string
  subTitleLink?: string
  button: string
  event: string
  route?: string
  external?: string
  link?: string
  reasons?: Reason[]
}

export interface Reason {
  key: string
  event: string
  hint?: string
}

export const ONBOARDING_STEPS: Step[] = [
  {
    title: "admin.components.onboardingProgress.setup.step1.title",
    event: "QuickStart",
    id: "quickStart",
    actions: [
      {
        name: "CUSTOMISE_LOGO_OR_COLOUR",
        complete: false,
        title: "admin.components.onboardingProgress.setup.step1.item1.title",
        subTitle: "admin.components.onboardingProgress.setup.step1.item1.subTitle",
        button: "admin.components.onboardingProgress.setup.step1.item1.button",
        event: "customLogo",
        route: SETTINGS_CUSTOMISE_BRAND
      },
      {
        name: "CUSTOMISE_WELCOME_MESSAGE",
        complete: false,
        title: "admin.components.onboardingProgress.setup.step1.item4.title",
        subTitle: "admin.components.onboardingProgress.setup.step1.item4.subTitle",
        button: "admin.components.onboardingProgress.setup.step1.item4.button",
        event: "customEmail",
        route: SETTINGS_CUSTOMISE_WELCOME_EMAIL
      },
      {
        name: "INVITE_ADMIN",
        complete: false,
        title: "admin.components.onboardingProgress.setup.step1.item2.title",
        subTitle: "admin.components.onboardingProgress.setup.step1.item2.subTitle",
        button: "admin.components.onboardingProgress.setup.step1.item2.title",
        event: "inviteAdmins",
        route: ADD_PEOPLE_SINGLE
      },
      {
        name: "CREATE_REGION",
        complete: false,
        title: "admin.components.onboardingProgress.setup.step1.item3.title",
        subTitle: "admin.components.onboardingProgress.setup.step1.item3.subTitle",
        button: "admin.components.onboardingProgress.setup.step1.item3.title",
        event: "addCountries",
        route: VIEW_BUSINESS_UNITS,
        reasons: [
          {
            key: "admin.components.onboardingProgress.setup.step1.item3.reasons.item1",
            event: "No global employees"
          },
          {
            key: "admin.components.onboardingProgress.setup.step1.item3.reasons.item2",
            event: "Don’t offer perkbox"
          },
          {
            key: "admin.components.onboardingProgress.setup.step1.item3.reasons.item3",
            event: "Other provider overseas"
          },
          {
            key: "admin.components.onboardingProgress.setup.step1.item3.reasons.item4",
            event: "Add countries later"
          }
        ]
      }
    ]
  },
  {
    title: "admin.components.onboardingProgress.setup.step2.title",
    event: "PromoteCulture",
    id: "promoteCulture",
    actions: [
      {
        name: "ADMIN_TOPUP",
        complete: false,
        title: "admin.components.onboardingProgress.setup.step2.item5.title",
        subTitle: "admin.components.onboardingProgress.setup.step2.item5.subTitle",
        button: "admin.components.onboardingProgress.setup.step2.item5.button",
        event: "rewardTopup",
        route: "/flexi-reward",
        external: appConfig[WALLET],
        reasons: [
          {
            key: "admin.components.onboardingProgress.setup.step2.item5.reasons.item1",
            event: "No reward budget"
          },
          {
            key: "admin.components.onboardingProgress.setup.step2.item5.reasons.item2",
            event: "Not ready to use rewards"
          },
          {
            key: "admin.components.onboardingProgress.setup.step2.item5.reasons.item3",
            event: "Not interested"
          }
        ]
      },
      {
        name: "CREATE_COMPANY_CELEBRATION",
        complete: false,
        title: "admin.components.onboardingProgress.setup.step2.item3.title",
        subTitle: "admin.components.onboardingProgress.setup.step2.item3.subTitle",
        button: "admin.components.onboardingProgress.setup.step2.item3.button",
        event: "companyCelebrations",
        route: SETTINGS_CUSTOMISE_CELEBRATIONS,
        reasons: [
          {
            key: "admin.components.onboardingProgress.setup.step2.item3.reasons.item3",
            event: "Do not use celebrations"
          },
          {
            key: "admin.components.onboardingProgress.setup.step2.item3.reasons.item1",
            event: "Post celebrations elsewhere"
          },
          {
            key: "admin.components.onboardingProgress.setup.step2.item3.reasons.item2",
            event: "Add celebrations later"
          }
        ]
      },
      {
        name: "CREATE_COMPANY_VALUE",
        complete: false,
        title: "admin.components.onboardingProgress.setup.step2.item2.title",
        subTitle: "admin.components.onboardingProgress.setup.step2.item2.subTitle",
        button: "admin.components.onboardingProgress.setup.step2.item2.title",
        event: "companyValues",
        route: SETTINGS_CUSTOMISE_VALUES,
        reasons: [
          {
            key: "admin.components.onboardingProgress.setup.step2.item2.reasons.item3",
            event: "Do not use values"
          },
          {
            key: "admin.components.onboardingProgress.setup.step2.item2.reasons.item1",
            event: "Post values elsewhere"
          },
          {
            key: "admin.components.onboardingProgress.setup.step2.item2.reasons.item2",
            event: "Do values later"
          }
        ]
      },
      {
        name: "CREATE_COMPANY_BENEFIT",
        complete: false,
        title: "admin.components.onboardingProgress.setup.step2.item1.title",
        subTitle: "admin.components.onboardingProgress.setup.step2.item1.subTitle",
        button: "admin.components.onboardingProgress.setup.step2.item1.title",
        event: "customBenefits",
        route: SETTINGS_CUSTOMISE_BENEFITS,
        reasons: [
          {
            key: "admin.components.onboardingProgress.setup.step2.item1.reasons.item1",
            event: "Don’t offer custom"
          },
          {
            key: "admin.components.onboardingProgress.setup.step2.item1.reasons.item2",
            event: "Post benefits elsewhere"
          },
          {
            key: "admin.components.onboardingProgress.setup.step2.item1.reasons.item3",
            event: "Do benefits later"
          }
        ]
      },
      {
        name: "CREATE_CULTURE_HUB_TILE",
        complete: false,
        title: "admin.components.onboardingProgress.setup.step2.item4.title",
        subTitle: "admin.components.onboardingProgress.setup.step2.item4.subTitle",
        button: "admin.components.onboardingProgress.setup.step2.item4.title",
        event: "editCultureHub",
        route: "/edit",
        external: appConfig[HOME],
        reasons: [
          {
            key: "admin.components.onboardingProgress.setup.step2.item4.reasons.item1",
            event: "Post culture elsewhere"
          },
          {
            key: "admin.components.onboardingProgress.setup.step2.item4.reasons.item2",
            event: "Lack understanding"
          },
          {
            key: "admin.components.onboardingProgress.setup.step2.item4.reasons.item3",
            event: "Do culture hub later"
          }
        ]
      }
    ]
  },
  {
    title: "admin.components.onboardingProgress.setup.step3.title",
    event: "AutomatePlatform",
    id: "automatePlatform",
    actions: [
      {
        name: "SSO_ENABLED",
        complete: false,
        title: "admin.components.onboardingProgress.setup.step3.item1.title",
        subTitle: "admin.components.onboardingProgress.setup.step3.item1.subTitle",
        button: "admin.components.onboardingProgress.setup.step3.item1.button",
        event: "SSO",
        route: SETTINGS_LOGIN_INTEGRATION_SSO,
        reasons: [
          {
            key: "admin.components.onboardingProgress.setup.step3.item1.reasons.item1",
            event: "Need help",
            hint: "admin.components.onboardingProgress.setup.step3.item1.reasons.item1Hint"
          },
          {
            key: "admin.components.onboardingProgress.setup.step3.item1.reasons.item2",
            event: "Unsure if need"
          },
          {
            key: "admin.components.onboardingProgress.setup.step3.item1.reasons.item3",
            event: "Do SSO later"
          }
        ]
      },
      {
        name: "MICROSOFT_TEAMS_ENABLED",
        complete: false,
        title: "admin.components.onboardingProgress.setup.step3.item2.title",
        subTitle: "admin.components.onboardingProgress.setup.step3.item2.subTitle",
        button: "admin.components.onboardingProgress.setup.step3.item2.button",
        event: "msTeamsBots",
        link: "admin.components.onboardingProgress.setup.step3.item2.link",
        reasons: [
          {
            key: "admin.components.onboardingProgress.setup.step3.item2.reasons.item1",
            event: "Slack"
          },
          {
            key: "admin.components.onboardingProgress.setup.step3.item2.reasons.item2",
            event: "Lack understanding"
          },
          {
            key: "admin.components.onboardingProgress.setup.step3.item2.reasons.item3",
            event: "Celebrate elsewhere"
          },
          {
            key: "admin.components.onboardingProgress.setup.step3.item2.reasons.item4",
            event: "Do teams later"
          }
        ]
      }
    ]
  },
  {
    title: "admin.components.onboardingProgress.setup.step4.title",
    event: "CreateOrganisation",
    id: "createOrganisation",
    actions: [
      {
        name: "CREATE_TEAM",
        complete: false,
        title: "admin.components.onboardingProgress.setup.step4.item2.title",
        subTitle: "admin.components.onboardingProgress.setup.step4.item2.subTitle",
        button: "admin.components.onboardingProgress.setup.step4.item2.title",
        event: "createTeams",
        route: ADD_TEAM
      },
      {
        name: "DIRECTORY_SYNC_ENABLED",
        complete: false,
        title: "admin.components.onboardingProgress.setup.step4.item1.title",
        subTitle: "admin.components.onboardingProgress.setup.step4.item1.subTitle",
        subTitleLink: "admin.components.onboardingProgress.setup.step4.item1.subTitleLink",
        button: "admin.components.onboardingProgress.setup.step4.item1.button",
        event: "DSYNC",
        route: SETTINGS_LOGIN_INTEGRATION_DSYNC,
        reasons: [
          {
            key: "admin.components.onboardingProgress.setup.step4.item1.reasons.item1",
            event: "Need help",
            hint: "admin.components.onboardingProgress.setup.step4.item1.reasons.item1Hint"
          },
          {
            key: "admin.components.onboardingProgress.setup.step4.item1.reasons.item2",
            event: "Incompatible HRIS"
          },
          {
            key: "admin.components.onboardingProgress.setup.step4.item1.reasons.item3",
            event: "Unsure if need"
          },
          {
            key: "admin.components.onboardingProgress.setup.step4.item1.reasons.item4",
            event: "Do DYSNC later"
          }
        ]
      },
      {
        name: "ASSIGN_TEAM_MANAGER",
        complete: false,
        title: "admin.components.onboardingProgress.setup.step4.item3.title",
        subTitle: "admin.components.onboardingProgress.setup.step4.item3.subTitle",
        button: "admin.components.onboardingProgress.setup.step4.item3.title",
        event: "assignManagers",
        route: ASSIGN_MANAGERS
      }
    ]
  }
]
